import conectaSus from './conecta-sus/index'

const repositories = {
    conectaSus
}

export const repositoryFactory = {
    get: scope => {
        if (typeof scope !== 'string') {
            throw new Error('The scope must be a string.')
        }

        if (scope.trim() === '') {
            throw new Error("The scope can't be empty.")
        }

        let target = null

        scope.split('.').forEach(s => s != '' && (target = target === null ? repositories[s] : target[s]))

        return target
    }
}
